/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DetailedAgentLog } from "./DetailedAgentLog";
export const GetDetailedAgentLogResponse = core.serialization.object({
    data: DetailedAgentLog,
});
